// extracted by mini-css-extract-plugin
module.exports = {"bannerItem":"_2YUZB","highlight":"_1-VlC","feature":"_1abzB","row1":"_37abK","row2":"_3tp7X","row2SmallFont":"_1s-I4","row3":"_2Kmgp","row4":"_3gtQp"};